import { useCallback, useMemo, useState } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- The legacy program timeline is built on the feed queries
import { getProgramFeedKey, useProgramFeedInfiniteQuery } from 'features/feed/queries';

export const useProgramTimelineFeed = ({ programId }: { programId: string }) => {
  const [topicId, setTopicId] = useState<string>();
  const [topicItemId, setTopicItemId] = useState<string>();

  const { data, fetchNextPage, hasNextPage, isFetching, isLoading } = useProgramFeedInfiniteQuery({
    feedKey: getProgramFeedKey({ programId, programTopicId: topicId ?? 'none' }),
    limit: 20,
    programId,
    programTopicId: topicId,
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: fix later
  const collection = data?.pages.flat() ?? [];

  const item = useMemo(
    () => (topicItemId ? collection.find((contentObject) => contentObject.id === topicItemId) : collection[0]),
    [collection, topicItemId],
  );

  const onSelectTopic = useCallback((topic?: { id: string }) => {
    setTopicId(topic?.id);
    setTopicItemId(undefined);
  }, []);

  const onSelectPost = useCallback((post?: { id: string }) => {
    setTopicItemId(post?.id);
  }, []);

  return useMemo(
    () => ({ collection, fetchNextPage, hasNextPage, isFetching, isLoading, item, onSelectPost, onSelectTopic }),
    [collection, fetchNextPage, hasNextPage, isFetching, isLoading, item, onSelectPost, onSelectTopic],
  );
};
